/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as SignupRouteImport } from "./routes/signup";
import { Route as SigninRouteImport } from "./routes/signin";
import { Route as ResetpwdRouteImport } from "./routes/resetpwd";
import { Route as ForgotpwdRouteImport } from "./routes/forgotpwd";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AppThemesRouteImport } from "./routes/_app.themes";
import { Route as AppTeachersRouteImport } from "./routes/_app.teachers";
import { Route as AppStudentsRouteImport } from "./routes/_app.students";
import { Route as AppSettingsRouteImport } from "./routes/_app.settings";
import { Route as AppReportcardsRouteImport } from "./routes/_app.reportcards";
import { Route as AppNewsRouteImport } from "./routes/_app.news";
import { Route as AppMarksRouteImport } from "./routes/_app.marks";
import { Route as AppExamsRouteImport } from "./routes/_app.exams";
import { Route as AppDashboardRouteImport } from "./routes/_app.dashboard";
import { Route as AppSupportRouteImport } from "./routes/_app._support";
import { Route as AppTeachersIndexRouteImport } from "./routes/_app.teachers.index";
import { Route as AppStudentsIndexRouteImport } from "./routes/_app.students.index";
import { Route as AppNewsIndexRouteImport } from "./routes/_app.news.index";
import { Route as AppMarksIndexRouteImport } from "./routes/_app.marks.index";
import { Route as AppExamsIndexRouteImport } from "./routes/_app.exams.index";
import { Route as AppBatchesIndexRouteImport } from "./routes/_app.batches.index";
import { Route as AppTeachersTeacherIdRouteImport } from "./routes/_app.teachers.$teacherId";
import { Route as AppStudentsStudentIdRouteImport } from "./routes/_app.students.$studentId";
import { Route as AppReportcardsReportCardIdRouteImport } from "./routes/_app.reportcards.$reportCardId";
import { Route as AppNewsNewsIdRouteImport } from "./routes/_app.news.$newsId";
import { Route as AppMarksMarkIdRouteImport } from "./routes/_app.marks.$markId";
import { Route as AppExamsExamIdRouteImport } from "./routes/_app.exams.$examId";
import { Route as AppBatchesBatchIdRouteImport } from "./routes/_app.batches.$batchId";
import { Route as AppSupportDocsRouteImport } from "./routes/_app._support.docs";
import { Route as AppSupportBgRouteImport } from "./routes/_app._support.bg";
import { Route as AppSupportUploadIndexRouteImport } from "./routes/_app._support.upload.index";
import { Route as AppSupportDashboardUploadIndexRouteImport } from "./routes/_app._support.dashboard-upload.index";

const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any);
const SigninRoute = SigninRouteImport.update({
  id: "/signin",
  path: "/signin",
  getParentRoute: () => rootRouteImport,
} as any);
const ResetpwdRoute = ResetpwdRouteImport.update({
  id: "/resetpwd",
  path: "/resetpwd",
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotpwdRoute = ForgotpwdRouteImport.update({
  id: "/forgotpwd",
  path: "/forgotpwd",
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppThemesRoute = AppThemesRouteImport.update({
  id: "/themes",
  path: "/themes",
  getParentRoute: () => AppRoute,
} as any);
const AppTeachersRoute = AppTeachersRouteImport.update({
  id: "/teachers",
  path: "/teachers",
  getParentRoute: () => AppRoute,
} as any);
const AppStudentsRoute = AppStudentsRouteImport.update({
  id: "/students",
  path: "/students",
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any);
const AppReportcardsRoute = AppReportcardsRouteImport.update({
  id: "/reportcards",
  path: "/reportcards",
  getParentRoute: () => AppRoute,
} as any);
const AppNewsRoute = AppNewsRouteImport.update({
  id: "/news",
  path: "/news",
  getParentRoute: () => AppRoute,
} as any);
const AppMarksRoute = AppMarksRouteImport.update({
  id: "/marks",
  path: "/marks",
  getParentRoute: () => AppRoute,
} as any);
const AppExamsRoute = AppExamsRouteImport.update({
  id: "/exams",
  path: "/exams",
  getParentRoute: () => AppRoute,
} as any);
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AppRoute,
} as any);
const AppSupportRoute = AppSupportRouteImport.update({
  id: "/_support",
  getParentRoute: () => AppRoute,
} as any);
const AppTeachersIndexRoute = AppTeachersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppTeachersRoute,
} as any);
const AppStudentsIndexRoute = AppStudentsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppStudentsRoute,
} as any);
const AppNewsIndexRoute = AppNewsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppNewsRoute,
} as any);
const AppMarksIndexRoute = AppMarksIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppMarksRoute,
} as any);
const AppExamsIndexRoute = AppExamsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppExamsRoute,
} as any);
const AppBatchesIndexRoute = AppBatchesIndexRouteImport.update({
  id: "/batches/",
  path: "/batches/",
  getParentRoute: () => AppRoute,
} as any);
const AppTeachersTeacherIdRoute = AppTeachersTeacherIdRouteImport.update({
  id: "/$teacherId",
  path: "/$teacherId",
  getParentRoute: () => AppTeachersRoute,
} as any);
const AppStudentsStudentIdRoute = AppStudentsStudentIdRouteImport.update({
  id: "/$studentId",
  path: "/$studentId",
  getParentRoute: () => AppStudentsRoute,
} as any);
const AppReportcardsReportCardIdRoute =
  AppReportcardsReportCardIdRouteImport.update({
    id: "/$reportCardId",
    path: "/$reportCardId",
    getParentRoute: () => AppReportcardsRoute,
  } as any);
const AppNewsNewsIdRoute = AppNewsNewsIdRouteImport.update({
  id: "/$newsId",
  path: "/$newsId",
  getParentRoute: () => AppNewsRoute,
} as any);
const AppMarksMarkIdRoute = AppMarksMarkIdRouteImport.update({
  id: "/$markId",
  path: "/$markId",
  getParentRoute: () => AppMarksRoute,
} as any);
const AppExamsExamIdRoute = AppExamsExamIdRouteImport.update({
  id: "/$examId",
  path: "/$examId",
  getParentRoute: () => AppExamsRoute,
} as any);
const AppBatchesBatchIdRoute = AppBatchesBatchIdRouteImport.update({
  id: "/batches/$batchId",
  path: "/batches/$batchId",
  getParentRoute: () => AppRoute,
} as any);
const AppSupportDocsRoute = AppSupportDocsRouteImport.update({
  id: "/docs",
  path: "/docs",
  getParentRoute: () => AppSupportRoute,
} as any);
const AppSupportBgRoute = AppSupportBgRouteImport.update({
  id: "/bg",
  path: "/bg",
  getParentRoute: () => AppSupportRoute,
} as any);
const AppSupportUploadIndexRoute = AppSupportUploadIndexRouteImport.update({
  id: "/upload/",
  path: "/upload/",
  getParentRoute: () => AppSupportRoute,
} as any);
const AppSupportDashboardUploadIndexRoute =
  AppSupportDashboardUploadIndexRouteImport.update({
    id: "/dashboard-upload/",
    path: "/dashboard-upload/",
    getParentRoute: () => AppSupportRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/forgotpwd": typeof ForgotpwdRoute;
  "/resetpwd": typeof ResetpwdRoute;
  "/signin": typeof SigninRoute;
  "/signup": typeof SignupRoute;
  "/dashboard": typeof AppDashboardRoute;
  "/exams": typeof AppExamsRouteWithChildren;
  "/marks": typeof AppMarksRouteWithChildren;
  "/news": typeof AppNewsRouteWithChildren;
  "/reportcards": typeof AppReportcardsRouteWithChildren;
  "/settings": typeof AppSettingsRoute;
  "/students": typeof AppStudentsRouteWithChildren;
  "/teachers": typeof AppTeachersRouteWithChildren;
  "/themes": typeof AppThemesRoute;
  "/bg": typeof AppSupportBgRoute;
  "/docs": typeof AppSupportDocsRoute;
  "/batches/$batchId": typeof AppBatchesBatchIdRoute;
  "/exams/$examId": typeof AppExamsExamIdRoute;
  "/marks/$markId": typeof AppMarksMarkIdRoute;
  "/news/$newsId": typeof AppNewsNewsIdRoute;
  "/reportcards/$reportCardId": typeof AppReportcardsReportCardIdRoute;
  "/students/$studentId": typeof AppStudentsStudentIdRoute;
  "/teachers/$teacherId": typeof AppTeachersTeacherIdRoute;
  "/batches/": typeof AppBatchesIndexRoute;
  "/exams/": typeof AppExamsIndexRoute;
  "/marks/": typeof AppMarksIndexRoute;
  "/news/": typeof AppNewsIndexRoute;
  "/students/": typeof AppStudentsIndexRoute;
  "/teachers/": typeof AppTeachersIndexRoute;
  "/dashboard-upload/": typeof AppSupportDashboardUploadIndexRoute;
  "/upload/": typeof AppSupportUploadIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/forgotpwd": typeof ForgotpwdRoute;
  "/resetpwd": typeof ResetpwdRoute;
  "/signin": typeof SigninRoute;
  "/signup": typeof SignupRoute;
  "/dashboard": typeof AppDashboardRoute;
  "/reportcards": typeof AppReportcardsRouteWithChildren;
  "/settings": typeof AppSettingsRoute;
  "/themes": typeof AppThemesRoute;
  "/bg": typeof AppSupportBgRoute;
  "/docs": typeof AppSupportDocsRoute;
  "/batches/$batchId": typeof AppBatchesBatchIdRoute;
  "/exams/$examId": typeof AppExamsExamIdRoute;
  "/marks/$markId": typeof AppMarksMarkIdRoute;
  "/news/$newsId": typeof AppNewsNewsIdRoute;
  "/reportcards/$reportCardId": typeof AppReportcardsReportCardIdRoute;
  "/students/$studentId": typeof AppStudentsStudentIdRoute;
  "/teachers/$teacherId": typeof AppTeachersTeacherIdRoute;
  "/batches": typeof AppBatchesIndexRoute;
  "/exams": typeof AppExamsIndexRoute;
  "/marks": typeof AppMarksIndexRoute;
  "/news": typeof AppNewsIndexRoute;
  "/students": typeof AppStudentsIndexRoute;
  "/teachers": typeof AppTeachersIndexRoute;
  "/dashboard-upload": typeof AppSupportDashboardUploadIndexRoute;
  "/upload": typeof AppSupportUploadIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteWithChildren;
  "/forgotpwd": typeof ForgotpwdRoute;
  "/resetpwd": typeof ResetpwdRoute;
  "/signin": typeof SigninRoute;
  "/signup": typeof SignupRoute;
  "/_app/_support": typeof AppSupportRouteWithChildren;
  "/_app/dashboard": typeof AppDashboardRoute;
  "/_app/exams": typeof AppExamsRouteWithChildren;
  "/_app/marks": typeof AppMarksRouteWithChildren;
  "/_app/news": typeof AppNewsRouteWithChildren;
  "/_app/reportcards": typeof AppReportcardsRouteWithChildren;
  "/_app/settings": typeof AppSettingsRoute;
  "/_app/students": typeof AppStudentsRouteWithChildren;
  "/_app/teachers": typeof AppTeachersRouteWithChildren;
  "/_app/themes": typeof AppThemesRoute;
  "/_app/_support/bg": typeof AppSupportBgRoute;
  "/_app/_support/docs": typeof AppSupportDocsRoute;
  "/_app/batches/$batchId": typeof AppBatchesBatchIdRoute;
  "/_app/exams/$examId": typeof AppExamsExamIdRoute;
  "/_app/marks/$markId": typeof AppMarksMarkIdRoute;
  "/_app/news/$newsId": typeof AppNewsNewsIdRoute;
  "/_app/reportcards/$reportCardId": typeof AppReportcardsReportCardIdRoute;
  "/_app/students/$studentId": typeof AppStudentsStudentIdRoute;
  "/_app/teachers/$teacherId": typeof AppTeachersTeacherIdRoute;
  "/_app/batches/": typeof AppBatchesIndexRoute;
  "/_app/exams/": typeof AppExamsIndexRoute;
  "/_app/marks/": typeof AppMarksIndexRoute;
  "/_app/news/": typeof AppNewsIndexRoute;
  "/_app/students/": typeof AppStudentsIndexRoute;
  "/_app/teachers/": typeof AppTeachersIndexRoute;
  "/_app/_support/dashboard-upload/": typeof AppSupportDashboardUploadIndexRoute;
  "/_app/_support/upload/": typeof AppSupportUploadIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/forgotpwd"
    | "/resetpwd"
    | "/signin"
    | "/signup"
    | "/dashboard"
    | "/exams"
    | "/marks"
    | "/news"
    | "/reportcards"
    | "/settings"
    | "/students"
    | "/teachers"
    | "/themes"
    | "/bg"
    | "/docs"
    | "/batches/$batchId"
    | "/exams/$examId"
    | "/marks/$markId"
    | "/news/$newsId"
    | "/reportcards/$reportCardId"
    | "/students/$studentId"
    | "/teachers/$teacherId"
    | "/batches/"
    | "/exams/"
    | "/marks/"
    | "/news/"
    | "/students/"
    | "/teachers/"
    | "/dashboard-upload/"
    | "/upload/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/forgotpwd"
    | "/resetpwd"
    | "/signin"
    | "/signup"
    | "/dashboard"
    | "/reportcards"
    | "/settings"
    | "/themes"
    | "/bg"
    | "/docs"
    | "/batches/$batchId"
    | "/exams/$examId"
    | "/marks/$markId"
    | "/news/$newsId"
    | "/reportcards/$reportCardId"
    | "/students/$studentId"
    | "/teachers/$teacherId"
    | "/batches"
    | "/exams"
    | "/marks"
    | "/news"
    | "/students"
    | "/teachers"
    | "/dashboard-upload"
    | "/upload";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/forgotpwd"
    | "/resetpwd"
    | "/signin"
    | "/signup"
    | "/_app/_support"
    | "/_app/dashboard"
    | "/_app/exams"
    | "/_app/marks"
    | "/_app/news"
    | "/_app/reportcards"
    | "/_app/settings"
    | "/_app/students"
    | "/_app/teachers"
    | "/_app/themes"
    | "/_app/_support/bg"
    | "/_app/_support/docs"
    | "/_app/batches/$batchId"
    | "/_app/exams/$examId"
    | "/_app/marks/$markId"
    | "/_app/news/$newsId"
    | "/_app/reportcards/$reportCardId"
    | "/_app/students/$studentId"
    | "/_app/teachers/$teacherId"
    | "/_app/batches/"
    | "/_app/exams/"
    | "/_app/marks/"
    | "/_app/news/"
    | "/_app/students/"
    | "/_app/teachers/"
    | "/_app/_support/dashboard-upload/"
    | "/_app/_support/upload/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  ForgotpwdRoute: typeof ForgotpwdRoute;
  ResetpwdRoute: typeof ResetpwdRoute;
  SigninRoute: typeof SigninRoute;
  SignupRoute: typeof SignupRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/signup": {
      id: "/signup";
      path: "/signup";
      fullPath: "/signup";
      preLoaderRoute: typeof SignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signin": {
      id: "/signin";
      path: "/signin";
      fullPath: "/signin";
      preLoaderRoute: typeof SigninRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/resetpwd": {
      id: "/resetpwd";
      path: "/resetpwd";
      fullPath: "/resetpwd";
      preLoaderRoute: typeof ResetpwdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/forgotpwd": {
      id: "/forgotpwd";
      path: "/forgotpwd";
      fullPath: "/forgotpwd";
      preLoaderRoute: typeof ForgotpwdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/themes": {
      id: "/_app/themes";
      path: "/themes";
      fullPath: "/themes";
      preLoaderRoute: typeof AppThemesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/teachers": {
      id: "/_app/teachers";
      path: "/teachers";
      fullPath: "/teachers";
      preLoaderRoute: typeof AppTeachersRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/students": {
      id: "/_app/students";
      path: "/students";
      fullPath: "/students";
      preLoaderRoute: typeof AppStudentsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/settings": {
      id: "/_app/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AppSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reportcards": {
      id: "/_app/reportcards";
      path: "/reportcards";
      fullPath: "/reportcards";
      preLoaderRoute: typeof AppReportcardsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/news": {
      id: "/_app/news";
      path: "/news";
      fullPath: "/news";
      preLoaderRoute: typeof AppNewsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/marks": {
      id: "/_app/marks";
      path: "/marks";
      fullPath: "/marks";
      preLoaderRoute: typeof AppMarksRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/exams": {
      id: "/_app/exams";
      path: "/exams";
      fullPath: "/exams";
      preLoaderRoute: typeof AppExamsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dashboard": {
      id: "/_app/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof AppDashboardRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/_support": {
      id: "/_app/_support";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppSupportRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/teachers/": {
      id: "/_app/teachers/";
      path: "/";
      fullPath: "/teachers/";
      preLoaderRoute: typeof AppTeachersIndexRouteImport;
      parentRoute: typeof AppTeachersRoute;
    };
    "/_app/students/": {
      id: "/_app/students/";
      path: "/";
      fullPath: "/students/";
      preLoaderRoute: typeof AppStudentsIndexRouteImport;
      parentRoute: typeof AppStudentsRoute;
    };
    "/_app/news/": {
      id: "/_app/news/";
      path: "/";
      fullPath: "/news/";
      preLoaderRoute: typeof AppNewsIndexRouteImport;
      parentRoute: typeof AppNewsRoute;
    };
    "/_app/marks/": {
      id: "/_app/marks/";
      path: "/";
      fullPath: "/marks/";
      preLoaderRoute: typeof AppMarksIndexRouteImport;
      parentRoute: typeof AppMarksRoute;
    };
    "/_app/exams/": {
      id: "/_app/exams/";
      path: "/";
      fullPath: "/exams/";
      preLoaderRoute: typeof AppExamsIndexRouteImport;
      parentRoute: typeof AppExamsRoute;
    };
    "/_app/batches/": {
      id: "/_app/batches/";
      path: "/batches";
      fullPath: "/batches/";
      preLoaderRoute: typeof AppBatchesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/teachers/$teacherId": {
      id: "/_app/teachers/$teacherId";
      path: "/$teacherId";
      fullPath: "/teachers/$teacherId";
      preLoaderRoute: typeof AppTeachersTeacherIdRouteImport;
      parentRoute: typeof AppTeachersRoute;
    };
    "/_app/students/$studentId": {
      id: "/_app/students/$studentId";
      path: "/$studentId";
      fullPath: "/students/$studentId";
      preLoaderRoute: typeof AppStudentsStudentIdRouteImport;
      parentRoute: typeof AppStudentsRoute;
    };
    "/_app/reportcards/$reportCardId": {
      id: "/_app/reportcards/$reportCardId";
      path: "/$reportCardId";
      fullPath: "/reportcards/$reportCardId";
      preLoaderRoute: typeof AppReportcardsReportCardIdRouteImport;
      parentRoute: typeof AppReportcardsRoute;
    };
    "/_app/news/$newsId": {
      id: "/_app/news/$newsId";
      path: "/$newsId";
      fullPath: "/news/$newsId";
      preLoaderRoute: typeof AppNewsNewsIdRouteImport;
      parentRoute: typeof AppNewsRoute;
    };
    "/_app/marks/$markId": {
      id: "/_app/marks/$markId";
      path: "/$markId";
      fullPath: "/marks/$markId";
      preLoaderRoute: typeof AppMarksMarkIdRouteImport;
      parentRoute: typeof AppMarksRoute;
    };
    "/_app/exams/$examId": {
      id: "/_app/exams/$examId";
      path: "/$examId";
      fullPath: "/exams/$examId";
      preLoaderRoute: typeof AppExamsExamIdRouteImport;
      parentRoute: typeof AppExamsRoute;
    };
    "/_app/batches/$batchId": {
      id: "/_app/batches/$batchId";
      path: "/batches/$batchId";
      fullPath: "/batches/$batchId";
      preLoaderRoute: typeof AppBatchesBatchIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/_support/docs": {
      id: "/_app/_support/docs";
      path: "/docs";
      fullPath: "/docs";
      preLoaderRoute: typeof AppSupportDocsRouteImport;
      parentRoute: typeof AppSupportRoute;
    };
    "/_app/_support/bg": {
      id: "/_app/_support/bg";
      path: "/bg";
      fullPath: "/bg";
      preLoaderRoute: typeof AppSupportBgRouteImport;
      parentRoute: typeof AppSupportRoute;
    };
    "/_app/_support/upload/": {
      id: "/_app/_support/upload/";
      path: "/upload";
      fullPath: "/upload/";
      preLoaderRoute: typeof AppSupportUploadIndexRouteImport;
      parentRoute: typeof AppSupportRoute;
    };
    "/_app/_support/dashboard-upload/": {
      id: "/_app/_support/dashboard-upload/";
      path: "/dashboard-upload";
      fullPath: "/dashboard-upload/";
      preLoaderRoute: typeof AppSupportDashboardUploadIndexRouteImport;
      parentRoute: typeof AppSupportRoute;
    };
  }
}

interface AppSupportRouteChildren {
  AppSupportBgRoute: typeof AppSupportBgRoute;
  AppSupportDocsRoute: typeof AppSupportDocsRoute;
  AppSupportDashboardUploadIndexRoute: typeof AppSupportDashboardUploadIndexRoute;
  AppSupportUploadIndexRoute: typeof AppSupportUploadIndexRoute;
}

const AppSupportRouteChildren: AppSupportRouteChildren = {
  AppSupportBgRoute: AppSupportBgRoute,
  AppSupportDocsRoute: AppSupportDocsRoute,
  AppSupportDashboardUploadIndexRoute: AppSupportDashboardUploadIndexRoute,
  AppSupportUploadIndexRoute: AppSupportUploadIndexRoute,
};

const AppSupportRouteWithChildren = AppSupportRoute._addFileChildren(
  AppSupportRouteChildren,
);

interface AppExamsRouteChildren {
  AppExamsExamIdRoute: typeof AppExamsExamIdRoute;
  AppExamsIndexRoute: typeof AppExamsIndexRoute;
}

const AppExamsRouteChildren: AppExamsRouteChildren = {
  AppExamsExamIdRoute: AppExamsExamIdRoute,
  AppExamsIndexRoute: AppExamsIndexRoute,
};

const AppExamsRouteWithChildren = AppExamsRoute._addFileChildren(
  AppExamsRouteChildren,
);

interface AppMarksRouteChildren {
  AppMarksMarkIdRoute: typeof AppMarksMarkIdRoute;
  AppMarksIndexRoute: typeof AppMarksIndexRoute;
}

const AppMarksRouteChildren: AppMarksRouteChildren = {
  AppMarksMarkIdRoute: AppMarksMarkIdRoute,
  AppMarksIndexRoute: AppMarksIndexRoute,
};

const AppMarksRouteWithChildren = AppMarksRoute._addFileChildren(
  AppMarksRouteChildren,
);

interface AppNewsRouteChildren {
  AppNewsNewsIdRoute: typeof AppNewsNewsIdRoute;
  AppNewsIndexRoute: typeof AppNewsIndexRoute;
}

const AppNewsRouteChildren: AppNewsRouteChildren = {
  AppNewsNewsIdRoute: AppNewsNewsIdRoute,
  AppNewsIndexRoute: AppNewsIndexRoute,
};

const AppNewsRouteWithChildren =
  AppNewsRoute._addFileChildren(AppNewsRouteChildren);

interface AppReportcardsRouteChildren {
  AppReportcardsReportCardIdRoute: typeof AppReportcardsReportCardIdRoute;
}

const AppReportcardsRouteChildren: AppReportcardsRouteChildren = {
  AppReportcardsReportCardIdRoute: AppReportcardsReportCardIdRoute,
};

const AppReportcardsRouteWithChildren = AppReportcardsRoute._addFileChildren(
  AppReportcardsRouteChildren,
);

interface AppStudentsRouteChildren {
  AppStudentsStudentIdRoute: typeof AppStudentsStudentIdRoute;
  AppStudentsIndexRoute: typeof AppStudentsIndexRoute;
}

const AppStudentsRouteChildren: AppStudentsRouteChildren = {
  AppStudentsStudentIdRoute: AppStudentsStudentIdRoute,
  AppStudentsIndexRoute: AppStudentsIndexRoute,
};

const AppStudentsRouteWithChildren = AppStudentsRoute._addFileChildren(
  AppStudentsRouteChildren,
);

interface AppTeachersRouteChildren {
  AppTeachersTeacherIdRoute: typeof AppTeachersTeacherIdRoute;
  AppTeachersIndexRoute: typeof AppTeachersIndexRoute;
}

const AppTeachersRouteChildren: AppTeachersRouteChildren = {
  AppTeachersTeacherIdRoute: AppTeachersTeacherIdRoute,
  AppTeachersIndexRoute: AppTeachersIndexRoute,
};

const AppTeachersRouteWithChildren = AppTeachersRoute._addFileChildren(
  AppTeachersRouteChildren,
);

interface AppRouteChildren {
  AppSupportRoute: typeof AppSupportRouteWithChildren;
  AppDashboardRoute: typeof AppDashboardRoute;
  AppExamsRoute: typeof AppExamsRouteWithChildren;
  AppMarksRoute: typeof AppMarksRouteWithChildren;
  AppNewsRoute: typeof AppNewsRouteWithChildren;
  AppReportcardsRoute: typeof AppReportcardsRouteWithChildren;
  AppSettingsRoute: typeof AppSettingsRoute;
  AppStudentsRoute: typeof AppStudentsRouteWithChildren;
  AppTeachersRoute: typeof AppTeachersRouteWithChildren;
  AppThemesRoute: typeof AppThemesRoute;
  AppBatchesBatchIdRoute: typeof AppBatchesBatchIdRoute;
  AppBatchesIndexRoute: typeof AppBatchesIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppSupportRoute: AppSupportRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppExamsRoute: AppExamsRouteWithChildren,
  AppMarksRoute: AppMarksRouteWithChildren,
  AppNewsRoute: AppNewsRouteWithChildren,
  AppReportcardsRoute: AppReportcardsRouteWithChildren,
  AppSettingsRoute: AppSettingsRoute,
  AppStudentsRoute: AppStudentsRouteWithChildren,
  AppTeachersRoute: AppTeachersRouteWithChildren,
  AppThemesRoute: AppThemesRoute,
  AppBatchesBatchIdRoute: AppBatchesBatchIdRoute,
  AppBatchesIndexRoute: AppBatchesIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotpwdRoute: ForgotpwdRoute,
  ResetpwdRoute: ResetpwdRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
